import { createAction } from '@reduxjs/toolkit';

export const setSendMethod = createAction('user/setSendMethod');
